import Vue from 'vue';
import ContentLayout from './ContentLayout';
import PageLayout from './PageLayout';

Vue.component('PageLayout', PageLayout);
Vue.component('ContentLayout', ContentLayout);
